import { DocType } from './db.mjs';
import { NameSpacer } from './namespacer.mjs';
import { FieldType } from './enums/FieldType.mjs';
export function prepareNote55(courseID, codeCourse, shape, 
// [ ] add typing
// eslint-disable-next-line @typescript-eslint/no-explicit-any
data, author, _tags, uploads) {
    const dataShapeId = NameSpacer.getDataShapeString({
        course: codeCourse,
        dataShape: shape.name,
    });
    const attachmentFields = shape.fields
        .map((field) => {
        // make a copy, in order NOT to append to the datashape
        const copy = {
            name: field.name,
            type: field.type,
        };
        return copy;
    })
        .filter((field) => {
        return field.type === FieldType.IMAGE || field.type === FieldType.AUDIO;
    })
        .concat([
        {
            name: 'autoplayAudio',
            type: FieldType.AUDIO,
        },
    ]);
    for (let i = 1; i < 11; i++) {
        if (data[`audio-${i}`]) {
            attachmentFields.push({
                name: `audio-${i}`,
                type: FieldType.AUDIO,
            });
        }
        if (data[`image-${i}`]) {
            attachmentFields.push({
                name: `image-${i}`,
                type: FieldType.IMAGE,
            });
        }
    }
    if (data[`audio-11`]) {
        throw new Error('Too many audio attachments');
    }
    if (data[`image-11`]) {
        throw new Error('Too many image attachments');
    }
    const attachments = {};
    const payload = {
        course: courseID,
        data: [],
        docType: DocType.DISPLAYABLE_DATA,
        id_datashape: dataShapeId,
    };
    if (author) {
        payload.author = author;
    }
    attachmentFields.forEach((attField) => {
        attachments[attField.name] = data[attField.name];
    });
    //
    if (uploads) {
        Object.keys(uploads).forEach((k) => {
            attachments[k] = uploads[k];
        });
    }
    if (attachmentFields.length !== 0 || (uploads && Object.keys(uploads).length)) {
        payload._attachments = attachments;
    }
    shape.fields
        .filter((field) => {
        return field.type !== FieldType.IMAGE && field.type !== FieldType.AUDIO;
    })
        .forEach((field) => {
        payload.data.push({
            name: field.name,
            data: data[field.name],
        });
    });
    return payload;
}
/**
 * Type guard to check if performance is structured (TaggedPerformance).
 */
export function isTaggedPerformance(p) {
    return typeof p === 'object' && p !== null && '_global' in p;
}
//# sourceMappingURL=course-data.js.map